import React, {useState} from 'react'

import AddUserDialog from './AddUserDialog'
import clsx from 'clsx'
import GlobalFilter from './GlobalFilter'
import {lighten, makeStyles} from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import AgentService from "../../../../services/AgentService";
import {toast} from "react-toastify";

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}))


const TableToolbar = props => {
    const [activateLoading, setActivateLoading] = useState(false);
    const [deactivateLoading, setDeactivateLoading] = useState(false);

    const activate = (id) => {
        setActivateLoading(true);
        //call activate endpoint
        AgentService.activate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' Agent Activated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                AgentService.getAllAgents().then(response => {
                    console.log(response.agents);
                    // setData(response.agents);
                    setActivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setActivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setActivateLoading(false);
            })

    }

    const deactivate = (id) => {
        setDeactivateLoading(true)
        //call deactivate endpoint
        AgentService.deactivate(parseInt(id))
            .then(res => {
                console.log(res);
                toast(' Agent Deactivated ', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                AgentService.getAllAgents().then(response => {
                    console.log(response.agents);
                    // setData(response.agents);
                    setDeactivateLoading(false)
                }).catch(err => {
                    console.log(err);
                });
                setDeactivateLoading(false)
            })
            .catch(err => {
                console.log(err);
                toast.warning('Operation failed: ' + err, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setDeactivateLoading(false)
            })
    }

    const classes = useToolbarStyles()
    const {
        numSelected,
        addUserHandler,
        deleteUserHandler,
        preGlobalFilteredRows,
        setGlobalFilter,
        globalFilter,
    } = props
    return (
        <Toolbar
            className={clsx(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <AddUserDialog addUserHandler={addUserHandler}/>
            {numSelected > 0 ? (
                <Typography
                    className={classes.title}
                    color="inherit"
                    variant="subtitle1"
                >
                    {numSelected} selected
                </Typography>
            ) : (
                <Typography className={classes.title} variant="h6" id="tableTitle">

                </Typography>
            )}

            {numSelected > 0 ? (
                <>
                    <Tooltip title="Delete">
                        <button className="btn btn-sm btn-warning" onClick={deleteUserHandler}>Deactivate
                            &nbsp;<i className="fa fa-check-circle"/></button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <button className="btn btn-sm btn-primary" onClick={activate}>Activate
                            &nbsp;<i className="fa fa-check-circle"/></button>
                    </Tooltip>
                </>

            ) : (
                <GlobalFilter
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                />
            )}
        </Toolbar>
    )
}

TableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    addUserHandler: PropTypes.func.isRequired,
    deleteUserHandler: PropTypes.func.isRequired,
    setGlobalFilter: PropTypes.func.isRequired,
    preGlobalFilteredRows: PropTypes.array.isRequired,
    globalFilter: PropTypes.string.isRequired,
}

export default TableToolbar
